import * as React from "react";
import {default as Transaction, ReconciliationStatus} from "../../model/transaction/Transaction";
import {Icon} from "../../hiberUiKit/src/atoms/Icon/Icon";
import IconWrapper from "../../hiberUiKit/src/atoms/Icon/IconWrapper";
import ButtonSecondary from "../../hiberUiKit/src/atoms/Buttons/ButtonSecondary";
import ButtonPrimary from "../../hiberUiKit/src/atoms/Buttons/ButtonPrimary";
import StripePayout from "../../model/transaction/StripePayout";
import GoCardlessPayout from "../../model/transaction/GoCardlessPayout";

interface ComponentProps {
	/**
	 * Transaction.
	 */
	transaction: Transaction | StripePayout | GoCardlessPayout;
	/**
	 * View details/reconcile button click callback.
	 */
	onClick: () => void;
	/**
	 * If true, reconciling this stripePayout is not possible.
	 */
	disableReconciliation?: boolean;
}

/**
 * Reconciliation status presenter for stripePayout details view.
 */
export default class TransactionStatusPresenter extends React.PureComponent <ComponentProps> {
	render() {
		switch (this.props.transaction.reconciliationStatus) {
			case ReconciliationStatus.IGNORED:
				return (
					<div className="c-common-details_buttons_container">
						<div className="c-common-details_buttons_status grey">Ignored</div>
					</div>
				);
			case ReconciliationStatus.RECONCILED:
				return (
					<div className="c-common-details_buttons_container">
						<IconWrapper icon={Icon.CheckMark} size={16} variant={"green"}/>
						<div className="c-common-details_buttons_status">
							Reconciled
						</div>
						<div className="c-common-details_buttons_last-button">
							<ButtonSecondary label={"View details"} onClick={this.props.onClick}/>
						</div>
					</div>
				);
			default:
				return (
					this.props.disableReconciliation ? null :
						<>
							<div className="c-common-details_buttons_container">
								<div className="c-common-details_buttons_last-button">
									<ButtonPrimary label={"Reconcile"} onClick={this.props.onClick}/>
									{this.props.transaction.matched &&
									<span className="c-common-details_buttons_match-indicator">!</span>}
								</div>
							</div>
						</>
				);
		}
	}
}
